export default __webpack_public_path__ + "static/media/khalti.143587e5.png";